"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (arr1, arr2) {
    return arr1.length === arr2.length && arr1.every(function (x, idx) {
        return x === arr2[idx];
    });
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/ticks/areArraysEqual.js
// module id = 111
// module chunks = 0